module.exports = __webpack_public_path__ + "d4a24473e01ef4ad0b32a7d065aa7e43.jpg";